import { getCollapsiblePanelStyles } from '../../shared/styles';

export const getAdGroupStyles = (components, theme) => ({
  collapsiblePanel: getCollapsiblePanelStyles(components, theme),
  toggle: {
    marginBottom: '0px',
    alignSelf: 'center',
  },
  adgroupShell: {
    display: 'flex',
    '& .base-options-stack': {
      width: '100%',
    },
    '& .collapse-container': {
      width: 'inherit',
    },
    '& .contextual-target': {
      maxWidth: '1000px',
    },
  },
  adgroupOptions: {
    maxWidth: '968px',
  },
  estimationPart: {
    flexGrow: '1',
    marginTop: '58px',
    marginLeft: '30px',
    '& > div': {
      position: 'sticky',
      top: '0px',
    },
  },
  estimationPartEditFlow: {
    flexGrow: '1',
    marginLeft: '30px',
    '& > div': {
      position: 'sticky',
      top: '0px',
    },
  },
  hide: {
    display: 'none',
  },
});
